import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';

@Injectable()
export class HhelpdeskService extends BaseCrudService<Hhelpdesk> {

  public uri = '/api/hhelpdesk/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance HhelpdeskService');
  }

  buildSentence(entity?: Hhelpdesk, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Equal}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.group ?
          `group${QueryOperator.Equal}${entity.group}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondName ?
          `secondName${QueryOperator.Contain}${entity.secondName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.lstNotGroup) {
        query = query.concat(
          `lstNotGroup.id${QueryOperator.Equal}${entity.lstNotGroup}${QueryOperator.Split}`
        );
      }
      if (entity.usredit) {
        query = query.concat(
          `usredit${QueryOperator.Equal}${entity.usredit}${QueryOperator.Split}`
        );
      }
      
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    
    // Agregar order by 
    //let sortOrder = 'asc';
    //this.httpParams = this.httpParams.set(QueryOperator.PageParam, '10');
    //this.httpParams = this.httpParams.set(QueryOperator.SizeParam, '1');
    //this.httpParams =  this.httpParams.set(QueryOperator.SortParam, `id,${sortOrder}`);
  
    return this.httpParams;
  }

 
  searchFilters(entity?: Hhelpdesk, event?: LazyLoadEvent, extraQueryCondition?: String[]): Observable<ResponsePageable<Hhelpdesk>> {

    const url = this.rutaServidor + '/api/hhelpdesk/search2';
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<Hhelpdesk>>(url, { params: this.buildSentence(entity, event) })
        .pipe(
            tap(response => {
              let contentFilter : Hhelpdesk[]=[];
                if (response.numberOfElements > 0) {
                    response.content.forEach((value) => {
                        // debugger;
                        this.addLogicToSearch(value);
                        this.convertToDate(value);
                    })
                 
                }
               //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
  } 
}


// WEBPACK FOOTER //
// ./src/app/core/services/hhelpdesk.service.ts